import { http } from "./http.js";

async function getVehicle(resource, id) {
  const response = await http.get(`/${resource}/${id}`);
  return {
    id: response.data.Id,
    number: response.data.Number,
    trailerNumber: response.data.TrailerNumber,
    carrier: {
      id: response.data.Carrier.Id,
      title: response.data.Carrier.Title,
    },
    type: { id: response.data.Type.Id, title: response.data.Type.Title },
    lengthMain: response.data.LengthMain,
    lengthAdditional: response.data.LengthAdditional,
    widthMain: response.data.WidthMain,
    widthAdditional: response.data.WidthAdditional,
    heightMain: response.data.HeightMain,
    heightAdditional: response.data.HeightAdditional,
    carryingCapacity: response.data.CarryingCapacity,
    isRemoved: response.data.IsRemoved,
    isConfirmed: response.data.IsConfirmed,
  };
}

async function updateVehicle(resource, id, entity) {
  const response = await http.put(`/${resource}/${id}`, entity);
  return response;
}

async function createVehicle(resource, entity) {
  const response = await http.post(`/${resource}`, entity);
  return response;
}

async function changeRemovedState(resource, entity) {
  const response = await http.patch(
    `/${resource}/${entity.id}/rpc/change-removed-state`,
    {
      value: !entity.isRemoved,
    },
  );
  return response;
}

export { getVehicle, updateVehicle, createVehicle, changeRemovedState };
